import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import type { FormField } from '../interfaces';

export const ScrollToFirstError = ({
    formFields,
}: {
    formFields: Array<FormField>;
}) => {
    const { errors, submitCount, isValidating } = useFormikContext();
    const lastScrolledSubmitCount = React.useRef(0);

    useEffect(() => {
        if (isValidating) return;
        if (submitCount === 0 || Object.keys(errors).length === 0) return;
        if (submitCount <= lastScrolledSubmitCount.current) return;

        const firstErrorField = formFields.find((f) => errors[f.id]);
        if (!firstErrorField) return;

        const el =
            document.getElementById(firstErrorField.id) ??
            document.querySelector<HTMLElement>(
                `[name="${firstErrorField.id}"]`,
            );

        el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        lastScrolledSubmitCount.current = submitCount;
    }, [submitCount, errors, isValidating]); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
};
